import { render, staticRenderFns } from "./RulesetSourcefieldModal.vue?vue&type=template&id=16763066&scoped=true"
import script from "./RulesetSourcefieldModal.vue?vue&type=script&lang=js"
export * from "./RulesetSourcefieldModal.vue?vue&type=script&lang=js"
import style0 from "./RulesetSourcefieldModal.vue?vue&type=style&index=0&id=16763066&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16763066",
  null
  
)

export default component.exports